import * as React from "react";

import { useDefaultWorkspaceId } from "@v1/features/analytics/useDefaultWorkspaceId";
import { Loader } from "@v2/components/Loader";
import { routes } from "@v2/utils/router";
import { generatePath, Navigate } from "react-router-dom";

export const InsightsRedirect: React.FC = () => {
  const workspaceId = useDefaultWorkspaceId();

  if (!workspaceId) {
    return <Loader />;
  }

  const redirectPath = generatePath(routes.analytics.insights, {
    workspaceId,
  });

  return <Navigate to={redirectPath} replace />;
};
